const faqs = [
  {
    question: 'What is Hire Digital?',
    answer:
      'Hire Digital connects companies with talent in marketing, digital, and content creation. We curate our expert network through a rigorous screening process, where members are evaluated for their technical skills, work experience, and their problem solving and communication skills.',
  },
  {
    question: 'How to start working with a talent?',
    answer:
      'Tell Hire Digital your requirements and talent needs, or let us know by <a href="https://hiredigital.com/brief">registering here</a>. Our talent specialists will curate and find you the most relevant match. You can interview your talent and start work immediately.',
  },
  {
    question: 'How to choose a talent?',
    answer:
      'We’ll match the best talent for your needs based on the required skills, expertise level, project size, budget, language, geography, experience, and other criteria. A decision is made by our experts with the help of AI-based algorithms. Only 3% of the talent we vet are accepted to our network - hence you can be assured of the quality.',
  },
  {
    question: 'How long will it take?',
    answer:
      'Companies typically take between 24 to 72 hours from the time when they inform Hire Digital of their talent needs, to start working with their matched talent.',
  },
  {
    question: 'What if I’m not satisfied?',
    answer:
      'Hire Digital provides satisfaction guarantees for its clients. If the talent does not perform up to your standard, Hire Digital will provide a talent replacement.',
  },
  {
    question: 'How much does it cost?',
    answer:
      'Hire Digital will find you talent that match your preferred rates. We cater to individual requests based on your specific talent needs.',
  },
];
export default faqs;
